<template>
  <div class="container-fluid autenticacao">
    <div class="card autenticacao-card autenticacao-card--compact">
      <div class="card-header">
        <div class="card-header-content">
          <div class="card-title-group">
            <div class="card-icon-badge">
              <i class="pi pi-file"></i>
            </div>
            <div>
              <h5 class="panel-title">Recibo de Retenção</h5>
              <p class="panel-subtitle">Emissão e impressão do Recibo de Retenção na fonte</p>
            </div>
          </div>
        </div>
      </div>
      <div id="topo" class="card-body">
        <div class="form-title-links">
          <span class="form-title"
            >Informe o CPF/CNPJ do prestador e o número da Nota Fiscal para emitir o Recibo de Retenção.</span
          >
        </div>

        <!-- Tipo de Validação (Pills) -->
        <div class="form-group-modern">
          <label class="form-label-section">Tipo de Documento:</label>
          <div class="radio-pill-group">
            <label class="radio-pill-item" :class="{ active: tipoValidacao === 'N' }">
              <RadioButton
                id="radio1"
                name="documento"
                value="N"
                v-model="tipoValidacao"
                tabindex="1"
              />
              <span>NFS-e</span>
            </label>
            <label class="radio-pill-item" :class="{ active: tipoValidacao === 'D' }">
              <RadioButton
                id="radio2"
                name="chave"
                value="D"
                v-model="tipoValidacao"
                tabindex="2"
              />
              <span>DAPS</span>
            </label>
          </div>
        </div>

        <!-- CPF/CNPJ Prestador -->
        <div class="form-group-modern">
          <label for="cpfCnpj" class="form-label-modern">CPF/CNPJ do prestador: *</label>
          <InputText
            id="cpfCnpj"
            type="text"
            @blur="validarDocumento()"
            placeholder="Digite o CPF ou CNPJ do prestador"
            autocomplete="off"
            tabindex="3"
            class="input-modern"
            v-model="documentoPrestador"
          />
        </div>

        <!-- Número da Nota Fiscal -->
        <div class="form-group-modern">
          <label for="chave" class="form-label-modern">Número da Nota Fiscal: *</label>
          <InputText
            id="chave"
            type="text"
            placeholder="Digite o número da nota"
            autocomplete="off"
            tabindex="4"
            class="input-modern"
            v-model="numero"
          />
        </div>

        <!-- Botões de Ação -->
        <div class="form-actions-modern" v-if="!sistemaBloqueado">
          <Button
            label="Voltar ao Login"
            type="button"
            class="btn-modern-secondary"
            id="btnVoltar"
            @click="login()"
            icon="pi pi-arrow-left"
            :disabled="loading"
          />
          <Button
            label="Imprimir Recibo"
            type="submit"
            class="btn-modern-primary"
            id="btnAutenticar"
            @click="visualizar()"
            icon="pi pi-print"
            :disabled="loading"
          />
        </div>
      </div>
    </div>

    <Dialog :header="tituloDialogSelecao" :visible.sync="showDialogSelecao"
            :style="{ width: '90vw', maxWidth: '1400px' }" :contentStyle="{ overflow: 'visible' }" :modal="true" :closable="false">
        <div style="background-color: #f8f9fa; padding: 10px 15px; margin-bottom: 10px; border-radius: 4px; border-left: 4px solid #007bff; font-size: 15px;">
          <i class="pi pi-info-circle" style="margin-right: 8px; color: #007bff;"></i>
          Foram encontrados <strong>{{registrosEncontrados.length}}</strong> registros com o número <strong>{{numero}}</strong>. Selecione o registro desejado para impressão do Recibo de Retenção.
        </div>
        <DataTable :value="registrosEncontrados" :paginator="true" :rows="5"
                   class="p-datatable-responsive" :autoLayout="true" style="min-width: 100%">
          <Column header="Imprimir" headerStyle="width: 70px" bodyStyle="text-align: center">
            <template #body="slotProps">
              <Button type="button" icon="pi pi-print" title="Imprimir"
                      @click="selecionarRegistro(slotProps.data)" />
            </template>
          </Column>
          <Column header="Número" headerStyle="width: 80px">
            <template #body="slotProps">
              <span class="p-column-title">Número</span>
              {{slotProps.data.numero}}
            </template>
          </Column>
          <Column header="Série" headerStyle="width: 80px" v-if="tipoSelecao === 'N'">
            <template #body="slotProps">
              <span class="p-column-title">Série</span>
              {{slotProps.data.serie}}
            </template>
          </Column>
          <Column header="Data Emissão" headerStyle="width: 110px">
            <template #body="slotProps">
              <span class="p-column-title">Data Emissão</span>
              {{slotProps.data.dataEmissao}}
            </template>
          </Column>
          <Column header="Prestador">
            <template #body="slotProps">
              <span class="p-column-title">Prestador</span>
              {{slotProps.data.documentoPrestador}} - {{slotProps.data.prestador}} 
            </template>
          </Column>
          <Column header="Tomador">
            <template #body="slotProps">
              <span class="p-column-title">Tomador</span>
              {{slotProps.data.documentoTomador}} - {{slotProps.data.tomador}}
            </template>
          </Column>
          <Column header="Valor" headerStyle="width: 100px">
            <template #body="slotProps">
              <span class="p-column-title">Valor</span>
              {{slotProps.data.valorServico}}
            </template>
          </Column>
        </DataTable>
      <div style="display: flex; justify-content: flex-start; padding: 5px 0;">
            <Button @click="cancelarSelecao()" type="button" label="Fechar"
                    class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import AutenticacaoService from "../services/nfse/autenticacao.service";
import DnsClienteService from "../services/nfse/dns.cliente.service";
import Util from "../Utils/util";

export default {
  data() {
    return {
      documentoPrestador: null,
      numero: null,
      tipoValidacao: null,
      loading: false,
      idCliente: null,
      anoAtual: null,
      showDialogSelecao: false,
      registrosEncontrados: [],
      registroSelecionado: null,
      tituloDialogSelecao: '',
      tipoSelecao: null,
      sistemaBloqueado: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      const el = document.getElementById("cpfCnpj");
      if (el) el.focus();
    });
    var d = new Date();
    this.anoAtual = d.getFullYear();

    if (!this.idCliente) {
      this.processando(true);
    }
    let host = window.location.hostname;
    DnsClienteService.get(host)
      .then((dns) => {
        if (dns && dns.data && dns.data.idCliente) {
          this.idCliente = dns.data.idCliente;
          if (dns.data.idBolBloquearSistema && dns.data.idBolBloquearSistema === 'S') {
            this.sistemaBloqueado = true;
          }
        }
      })
      .finally(() => {
        this.processando(false);
      });
  },

  created() {
    try {
      const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          this.idCliente = cached.idCliente || null;
          this.sistemaBloqueado = !!cached.sistemaBloqueado;
        }
      }
    } catch (e) {
      console.warn(e);
    }

    this.limparDados();
    this.documentoPrestador = this.$route.query.cpfCnpj;
    this.numero = this.$route.query.numero;
    this.tipoValidacao = this.$route.query.tipo ? this.$route.query.tipo : "N";
  },

  methods: {
    limparDados() {
      this.documentoPrestador = null;
      this.numero = null;
      this.tipoValidacao = "N";
      this.loading = false;
      this.showDialogSelecao = false;
      this.registrosEncontrados = [];
      this.registroSelecionado = null;
      this.tituloDialogSelecao = '';
      this.tipoSelecao = null;
    },

    login() {
      this.$router.push("/login");
    },

    visualizar() {
      this.processando(true);
      if (
        this.documentoPrestador &&
        this.numero &&
        this.tipoValidacao &&
        this.idCliente
      ) {
        AutenticacaoService.validaReciboRetencao(
          this.tipoValidacao,
          this.documentoPrestador,
          this.numero,
          this.idCliente
        )
          .then(
            response => {
              var retorno = response.data;
              if (retorno.multiplo) {                
                this.registrosEncontrados = retorno.registros;
                this.tipoSelecao = retorno.tipo;
                this.tituloDialogSelecao = retorno.tipo === 'N'
                  ? 'Selecione a Nota Fiscal'
                  : 'Selecione a DAPS';
                this.showDialogSelecao = true;
              }
            },
            error => {
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    selecionarRegistro(registro) {
      var idNfs = registro.id;
      var tipo = this.tipoValidacao;
      var idCliente = this.idCliente;

      this.showDialogSelecao = false;
      this.registrosEncontrados = [];
      this.registroSelecionado = null;

      AutenticacaoService.imprimirReciboRetencaoPorId(tipo, idCliente, idNfs);
    },

    cancelarSelecao() {
      this.showDialogSelecao = false;
      this.registrosEncontrados = [];
      this.registroSelecionado = null;
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoPrestador);

      if (!validar && this.documentoPrestador) {
        console.log(validar);
        this.$root.$emit("alert:error", "CPF/CNPJ inválido!");
      }
    }
  }
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>